// extracted by mini-css-extract-plugin
module.exports = {"home__section":"Home_home__section__1PWV0","human":"Home_human__1pzdN"};